<div class="portalnav-wrap por-ac-invoices">
    <div class="portalnav wrapper" [ngStyle]="{ height: height, width: width }" class="wrapper">
        <div class="wrapper heading-section">
            @if (appFacadeService.getCustomer() | async; as customer) {
            <h1 class="theme-heading">{{ 'InvoicesListFor' | translate | uppercase }} {{ customer?.Name }}</h1>
            }
        </div>
        <div id="mainportalpage" class="main-invoice-page">
            @if (appFacadeService.getSubActiveTab() | async; as tab) {
            <div [hidden]="tab !== 'Default'">
                <ng-container [ngTemplateOutlet]="invoices"></ng-container>
            </div>
            <div [hidden]="tab !== 'InvoiceDetail'">
                <ng-container [ngTemplateOutlet]="invoiceDetail"></ng-container>
            </div>
            }
        </div>
    </div>
</div>
<ng-template #invoices>
    <div class="date-range" [ngClass]="{ paymentButtonVisible: isMultiPaymentAvailable() }">
        <por-filters
            [initFilters]="initialStatusFilters"
            [isProcessing]="(appFacadeService.getLoader() | async) || false"
            [searchPlaceholder]="filterComponentProps.searchPlaceHolder"
            [dateLabel]="filterComponentProps.dateLabel"
            [singleFilters]="statusFilterOptions"
            [singleFiltersDefaultValue]="singleFiltersDefaultValue"
            [showClearSingleFilter]="false"
            [singleFilterAsToggle]="true"
            (filterOutput)="filter($any($event))"
            (exportCSV)="exportCSV()"
            [uiUrl]="uiUrl"
            [enableExport]="$any(invoices$ | async | count) > 0"
            [startDateLabel]="'InvoiceStartDateLabel'"
            [endDateLabel]="'End Date'"></por-filters>
        @if ( isMultiPaymentAvailable() ) {
        <div class="invoice-payment-button">
            @if (selectedInvoices.length === 0) {
            <por-base-button (click)="filterPayableInvoices()" [theme]="'primary'" [featureName]="'invoice-payment-toggle-button'" class="split-button ml-625">
                <por-pay-icon-text [label]="'PayInvoices'" [checked]="payInvoicesClicked()"></por-pay-icon-text>
            </por-base-button>
            } @if (selectedInvoices.length > 0) {
            <por-base-button
                #payInvoicesPanelTrigger="cdkOverlayOrigin"
                cdkOverlayOrigin
                (click)="toggleOverlay(true)"
                [theme]="'primary'"
                [featureName]="'invoice-payment-button'"
                class="split-button ml-625">
                <por-base-mat-badge [badgeContent]="selectedInvoices.length" [isHidden]="selectedInvoices.length === 0" badgeColor="warn"></por-base-mat-badge>
                <por-pay-icon-text [label]="'PayInvoices'" [checked]="payInvoicesClicked()"></por-pay-icon-text>
            </por-base-button>
            <por-multi-payment-invoice-panel
                [featureName]="'invoice-multipayment-panel'"
                [isOpen]="overlayStates"
                [trigger]="payInvoicesPanelTrigger"
                (closeOverlay)="toggleOverlay(false)"></por-multi-payment-invoice-panel>
            }
        </div>
        @if (payInvoicesClicked()) {
        <span class="click-title theme-paragraph">{{ 'SelectInvoicesToPayInstruction' | translate }}</span>
        } }
    </div>
    <div class="content-wrapper">
        @if (invoiceTotalAmountDue$ | async; as invoiceTotalAmountDue) {
        <div class="amount-due-wrap">
            <span>{{ 'TotalDue' | translate }} : {{ invoiceTotalAmountDue | formatCurrency }}</span>
        </div>
        } @if (gridReadyObservable$ | async) {
        <ag-grid-angular
            style="width: 100%; height: 100%"
            class="ag-theme-alpine ag-grid"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [rowSelection]="rowSelection"
            [rowData]="invoices$ | async"
            [animateRows]="true"
            [rowHeight]="rowHeight"
            [headerHeight]="headerHeight"
            (gridReady)="onGridReady($event)"
            [isFullWidthRow]="isFullWidthRow"
            [fullWidthCellRenderer]="fullWidthCellRenderer"
            [context]="context"
            [suppressRowClickSelection]="true"></ag-grid-angular>
        }
    </div>
    <div class="middle">
        <por-load-more [hasMoreRecord]="(noMoreRecord$ | async) ?? false" [featureName]="'load-more-invoice'" (loadMore)="loadMore()"></por-load-more>
    </div>
    @if ((appFacadeService.isDialogDisplayed() | async) && (appFacadeService.getDialogContentType() | async) === dialogContentType.Failed) {
    <por-app-confirm-dialog [message]="''" [dialogType]="dialogType" (confirmed)="appFacadeService.toggleDialog(false)">
        <p>{{ 'InvoiceFailedToLoad' | translate }}</p>
    </por-app-confirm-dialog>
    }
</ng-template>
<por-payment-success-dialog></por-payment-success-dialog>
<ng-template #invoiceDetail>
    @if (appFacadeService.getInvoiceDetail() | async; as invoiceDetail) {
    <div class="contract-details-page">
        @if (invoiceDetail) {
        <por-invoice-detail [invoiceDetail]="invoiceDetail" [uiUrl]="uiUrl" (closePanel)="closeInvoiceDetail()"></por-invoice-detail>
        }
    </div>
    }
</ng-template>
<por-base-modal [id]="'payment-modal'" [modalWidth]="'modal-lg'" (onclose)="onPaymentClose()">
    <por-multipayment></por-multipayment>
</por-base-modal>
